import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/theme.css';
import React, { Component } from 'react';
import { BrowserRouter, Route, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../actions';

import ScrollToTopOnRouteChange from './ScrollToTopOnRouteChange';
import BackgroundManager from './BackgroundManager';

import RouteAwareHeader from './header/RouteAwareHeader';

import Home from './home/Main';

import Login from './login/Main';
import Logout from './Logout';

import Waitlist from './Waitlist';
import WaitlistNoAccess from './WaitlistNoAccess';
import NoAccess from './NoAccess';

// New semantic onboarding components
import PlatformSelection from './onboarding/PlatformSelection';
import UsernameInput from './onboarding/UsernameInput';
import LeagueSelection from './onboarding/LeagueSelection';
import RoastLevelSelection from './onboarding/RoastLevelSelection';
import LeaguePersonalizationInput from './onboarding/LeaguePersonalizationInput';
import WeeklyContextInput from './onboarding/WeeklyContextInput';

// Existing onboarding components (renamed routes)
import OnboardingAuth from './onboarding/OnboardingAuth';
import PlanSelection from './onboarding/PlanSelection';
import CheckEmail from './onboarding/CheckEmail';

import SelectAccount from './select-account/Main';
import SubscriptionConfirmation from './SubscriptionConfirmation';



import Dashboard from './dashboard/Main';
import LeagueContextPage from './LeagueContextPage';
import WeeklyContextPage from './WeeklyContextPage';

import Resources from './resources/Main';

import Settings from './Settings';
import Contact from './Contact';

import Privacy from './legal/Privacy';
import Terms from './legal/Terms';


import Footer from './Footer';
import Enterprise from './Enterprise';

// Wrapper component to conditionally render Enterprise
const ConditionalEnterprise = () => {
    const location = useLocation();
    return location.pathname === '/' ? <Enterprise /> : null;
};

// Wrapper component to handle route changes and refresh user data
const RouteChangeHandler = ({ fetchUser, auth }) => {
    const location = useLocation();
    
    React.useEffect(() => {
        // Refresh user data on every route change if user is authenticated
        if (auth?.user?.id) {            
            fetchUser();
        }
    }, [location.pathname, auth?.user?.id, fetchUser]);
    
    return null;
};

class App extends Component {

    componentDidMount() {
        // Hydrate auth state immediately from localStorage
        this.hydrateAuthState();
        
        // Then fetch fresh data from server in background
        this.props.fetchUser();        
    }

    componentDidUpdate() {
        
    }

    hydrateAuthState() {
        try {
            const savedAuthData = localStorage.getItem('authData');
            
            if (savedAuthData) {
                const parsedAuthData = JSON.parse(savedAuthData);
                
                // Only hydrate if the data looks valid
                if (parsedAuthData && parsedAuthData.id) {
                    this.props.hydrateAuth(parsedAuthData);
                }
            }
        } catch (error) {
            console.error('Error hydrating auth state:', error);
            // Clear corrupted data
            localStorage.removeItem('authData');
        }
    }

    renderAnalytics() {
        
              
    }

    render() {        
        
        
        return (
            <>
                <BrowserRouter>                                        
                    <ScrollToTopOnRouteChange />
                    <BackgroundManager />
                    <RouteAwareHeader />
                    <RouteChangeHandler fetchUser={this.props.fetchUser} auth={this.props.auth} />

                    
                    <div className="container-fluid px-0" style={{ position:"relative", width:"100%"}}>
                        
                        <div className="min-vh-100 pb-5">
                            <Route exact path="/" component={Home} />

                            <Route exact path="/login" component={Login} />
                            <Route exact path="/logout" component={Logout} />
                            <Route exact path="/check-your-email" component={CheckEmail} />

                            <Route exact path="/waitlist-no-access" component={WaitlistNoAccess} />
                            <Route exact path="/no-access" component={NoAccess} />
                            <Route exact path="/waitlist" component={Waitlist} />                            

                            {/* New semantic onboarding routes */}
                            <Route exact path="/onboarding/platform" component={PlatformSelection} />
                            <Route exact path="/onboarding/username" component={UsernameInput} />
                            <Route exact path="/onboarding/leagues" component={LeagueSelection} />
                            
                            {/* Existing onboarding routes (renamed) */}
                            <Route exact path="/onboarding/auth" component={OnboardingAuth} />
                            <Route exact path="/onboarding/roast-level" component={RoastLevelSelection} />
                            <Route exact path="/onboarding/league-context" component={LeaguePersonalizationInput} />
                            <Route exact path="/onboarding/weekly-context" component={WeeklyContextInput} />
                            <Route exact path="/onboarding/plan" component={PlanSelection} />
                            
                            <Route exact path="/select-account" component={SelectAccount} />
                            <Route exact path="/subscription-confirmation" component={SubscriptionConfirmation} />

                                                {/* <Route exact path="/invite" component={Invite} />
                    <Route exact path="/invite-signup" component={InviteSignup} />
                    <Route exact path="/invite-signup/:code" component={InviteSignup} /> */}                            

                            <Route exact path="/dashboard" component={Dashboard} />
                            <Route exact path="/dashboard/:page" component={Dashboard} />

                            <Route exact path="/league-context" component={LeagueContextPage} />
                            <Route exact path="/weekly-context" component={WeeklyContextPage} />

                            <Route exact path="/resources" component={Resources} />

                            <Route exact path="/settings" component={Settings} />
                            <Route exact path="/contact" component={Contact} />
                            <Route exact path="/privacy" component={Privacy} />
                            <Route exact path="/terms" component={Terms} />
                                                {/* <Route exact path="/request" component={Request} />
                    <Route exact path="/request-confirmation" component={RequestConfirmation} /> */}
                        </div>
                        <ConditionalEnterprise />
                        <div className="container-fluid px-0" style={{ overflowX: 'hidden' }} >
                            <Footer />  
                        </div>
                    </div>                               
                </BrowserRouter>
            </>
        );
    }
};



function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps, actions)(App);
